import DOMPurify from 'dompurify';

/**
 * Sanitize HTML content to prevent XSS attacks.
 * Allows safe HTML tags for blog/CMS content rendering.
 */
export const sanitizeHTML = (dirty) => {
  if (!dirty) return '';
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS: [
      'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'br', 'hr',
      'ul', 'ol', 'li', 'a', 'strong', 'b', 'em', 'i', 'u',
      'blockquote', 'code', 'pre', 'img', 'table', 'thead',
      'tbody', 'tr', 'th', 'td', 'span', 'div', 'figure',
      'figcaption', 'video', 'source', 'iframe',
    ],
    ALLOWED_ATTR: [
      'href', 'src', 'alt', 'title', 'class', 'id', 'style',
      'target', 'rel', 'width', 'height', 'loading', 'data-testid',
      'colspan', 'rowspan', 'controls', 'type', 'allow', 'allowfullscreen',
      'frameborder',
    ],
    ALLOW_DATA_ATTR: false,
  });
};
